import { render } from "./Pagination.vue?vue&type=template&id=2d8a2793&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"

import "./Pagination.vue?vue&type=style&index=0&id=2d8a2793&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2d8a2793"

export default script